<div class="his-safe-html" [innerHTML]="trusted" lang="{{language ? language :'de'}}"></div>